import { render, staticRenderFns } from "./CreatePlace.vue?vue&type=template&id=4207356a&"
import script from "./CreatePlace.vue?vue&type=script&lang=js&"
export * from "./CreatePlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports